import { get } from 'app/common/helpers/fetch';

/**
 * Fetch cart size
 */
export function fetchCartSize() {
  const endpoint = '/cart/size';
  return get(endpoint)
    .then(result => {
      if (result && result.quantity_value) {
        return result.quantity_value;
      }
      return 0;
    })
    .catch(() => 0);
}
